var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"skip-link",attrs:{"href":"#colorlib-main","id":"skip-content"},domProps:{"innerHTML":_vm._s(_vm.languageData['skipContent'])}})}
var staticRenderFns = []

export { render, staticRenderFns }